module.exports = __webpack_public_path__ + "img/logout.a83933d5.svg";